import * as t from 'io-ts'
import { jsonRequest } from './ajax'

const ID = t.union([t.string, t.number])
type ID = t.TypeOf<typeof ID>

const ResendSignatureResponse = t.type({
  status: t.literal('OK'),
  message: t.string,
})

export async function resendSignatureConfirmation(signatureId: ID) {
  return await jsonRequest(
    ResendSignatureResponse,
    'POST',
    `/signatures/${signatureId}/resend`
  )
}
